import React, { ReactNode } from "react";
import { Card, CardContent, Typography, Divider } from "@mui/material";

interface SectionProps {
  title: string;
  children: ReactNode;
}

export default function Section({ title, children }: SectionProps) {
  return (
    <Card sx={{ mb: 4, borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} mb={2}>
          {title}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {children}
      </CardContent>
    </Card>
  );
}
